import { Moment } from 'moment';
import { CreateTimeKeepingEntry } from '../../../models/TimeKeeping';
import { DateTimeString } from '../../../models/Types';
import moment from 'moment';

export const calculateTimeKeepingEntries: (
  startTime: DateTimeString,
  endTime: DateTimeString
) => CreateTimeKeepingEntry[] = (startTime, endTime) => {
  const _startTime: Moment = moment(startTime);
  const _endTime: Moment = moment(endTime);
  const diffInMinutes = _endTime.diff(_startTime, 'minutes');
  const startDiffInMinutes = Math.round(diffInMinutes / 2 / 15) * 15 - 15;
  if (diffInMinutes >= 585) {
    // 9:45
    return [
      {
        startTime: toISOString(startTime),
        endTime: _startTime
          .clone()
          .add(startDiffInMinutes, 'minutes')
          .toISOString(true)
          .split('.')[0],
      },
      {
        startTime: _startTime
          .clone()
          .add(startDiffInMinutes + 45, 'minutes')
          .toISOString(true)
          .split('.')[0],
        endTime: toISOString(endTime),
      },
    ];
  } else if (diffInMinutes >= 390) {
    //6:30
    return [
      {
        startTime: toISOString(startTime),
        endTime: _startTime
          .clone()
          .add(startDiffInMinutes, 'minutes')
          .toISOString(true)
          .split('.')[0],
      },
      {
        startTime: _startTime
          .clone()
          .add(startDiffInMinutes + 30, 'minutes')
          .toISOString(true)
          .split('.')[0],
        endTime: toISOString(endTime),
      },
    ];
  }
  return [
    {
      startTime: toISOString(startTime),
      endTime: toISOString(endTime),
    },
  ];
};

export const toISOString = (ts: string | Date) =>
  moment(ts).toISOString(true).substring(0, 19);
